import React from 'react';

const PostJobSkeleton = () => {
  return (
    <div className=" animate-pulse w-full flex flex-col gap-6">
        {/* Task Details Section */}
        <div className="flex flex-col gap-6">
          {/* Section Heading */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gray-200"></div>
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          
          {/* Fields */}
          <div className="flex flex-col gap-6">
            <div className="flex flex-col md:flex-row gap-[30px]">
              {/* Title Field */}
              <div className="flex-grow flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-24"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
              
              {/* Date Field */}
              <div className="w-full md:w-[264px] flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-16"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
              
              {/* Time Field */}
              <div className="w-full md:w-[264px] flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-16"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
            </div>
            
            {/* Description Field */}
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-32"></div>
              <div className="h-24 bg-gray-200 rounded-lg w-full"></div>
            </div>
          </div>
        </div>

        {/* Task Category Section */}
        <div className="w-full flex gap-6 flex-col">
          {/* Section Heading */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gray-200"></div>
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          
          {/* Fields */}
          <div className="flex md:flex-row lg:gap-[30px] flex-col gap-8">
            {/* Category Dropdown */}
            <div className="w-full md:w-[400px] flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-24"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
            
            {/* Skills Dropdown */}
            <div className="w-full flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-16"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
          </div>
        </div>

        {/* Task Location Section */}
        <div className="w-full flex flex-col gap-6">
          {/* Section Heading */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gray-200"></div>
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>
          
          {/* Fields */}
          <div className="flex md:flex-row lg:gap-[30px] flex-col gap-8">
            {/* City Dropdown */}
            <div className="w-full md:w-[400px] flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-16"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
            
            {/* Sub City Dropdown */}
            <div className="w-full flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-24"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
          </div>
        </div>

        {/* Additional Requirement Section */}
        <div className="flex flex-col gap-4">
          {/* Section Heading */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-gray-200"></div>
            <div className="h-6 bg-gray-200 rounded w-64"></div>
          </div>
          
          {/* Image Upload Area */}
          <div className="flex flex-col gap-2">
            <div className="h-5 bg-gray-200 rounded w-20"></div>
            <div className="h-40 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
              <div className="h-8 w-40 bg-gray-300 rounded"></div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-12">
          <div className="w-full border-[1px] border-gray-200"></div>
          <div className="flex flex-row gap-4 justify-end">
            <div className="h-[46px] w-[120px] bg-gray-200 rounded-xl"></div>
            <div className="h-[46px] w-[120px] bg-gray-200 rounded-xl"></div>
          </div>
        </div>
    </div>
  );
};

export default PostJobSkeleton;